import { createSelector } from '@reduxjs/toolkit';
import { firstResultsFetchedSelector } from '../../searchStatus/selectors';
import { isEmptySearchSelector } from '../emptySearch/selectors';

import type { PriceChartState } from './types';
import { name } from './slice';

export const priceChartSelector = (state): PriceChartState => state.get(name);

export const priceChartResultSelector = createSelector(
  [priceChartSelector],
  (state) => state.result,
);

export const priceChartFetchingDirectionSelector = createSelector(
  [priceChartSelector],
  (state) => state.direction,
);

export const priceChartIsFetchingSelector = createSelector(
  [priceChartSelector],
  (state) => state.isFetching,
);

/**
 * Показываем статистику цен,
 * если есть первые результаты с отелями или попали на пустую выдачу
 */
export const isShowingPriceChartSelector = createSelector(
  [firstResultsFetchedSelector, isEmptySearchSelector],
  (hasHotels, isEmptySearch) => !(hasHotels || isEmptySearch),
);

/* 
  В случае если запрос вернулся пустым
*/
export const isEmptyResponsePriceChartSelector = createSelector(
  [priceChartIsFetchingSelector, priceChartResultSelector],
  (isFetching, result) => !isFetching && !result.length,
);
